import React, { useEffect } from "react";
import ClipLoader from 'react-spinners/ClipLoader';

const EventForm = ({
  eventName,
  setEventName,
  category,
  setCategory,
  recurrence,
  setRecurrence,
  eventDate,
  setEventDate,
  isEditing,
  handleSubmit,
  hideModal,
  isLoading,
}) => {

  useEffect(() => {
    if (category === 'not-fixed') {
      setEventDate('');
    }
  }, [category, setEventDate]);

  return (
    <form onSubmit={handleSubmit}>
      <div className="mb-4">
        <label className="block text-gray-800 text-sm font-bold mb-2">Event Name</label>
        <input
          type="text"
          value={eventName}
          onChange={(e) => setEventName(e.target.value)}
          required
          className="shadow appearance-none border squared w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-800 text-sm font-bold mb-2">Event Category</label>
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          className="shadow appearance-none border squared w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
        >
          <option value="fixed">Fixed (Admin Sets Date)</option>
          <option value="not-fixed">Not Fixed (User Sets Date)</option>
        </select>
      </div>
      <div className="mb-4">
        <label className="block text-gray-800 text-sm font-bold mb-2">Recurrence</label>
        <select
          value={recurrence}
          onChange={(e) => setRecurrence(e.target.value)}
          className="shadow appearance-none border squared w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
        >
          <option value="one-time">One-Time</option>
          <option value="annual">Annual</option>
          <option value="monthly">Monthly</option>
          <option value="weekly">Weekly</option>
        </select>
      </div>
      {category === "fixed" && (
        <div className="mb-4">
          <label className="block text-gray-800 text-sm font-bold mb-2">Event Date</label>
          <input
            type="date"
            value={eventDate}
            onChange={(e) => setEventDate(e.target.value)}
            required={category === "fixed"}
            className="shadow appearance-none border squared w-full py-2 px-3 text-gray-600 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
      )}
      <div className="flex items-center justify-between">
        <button 
          type="submit" 
          className="bg-primary text-white px-4 py-2 squared hover:bg-primary-dark" 
          disabled={isLoading}
        >
          {isLoading ? <ClipLoader size={24} color={"#fff"} /> : (isEditing ? "Update Event" : "Create Event")}
        </button>
        <button 
          type="button" 
          onClick={hideModal} 
          className="bg-gray-600 text-white px-4 py-2 squared hover:bg-gray-800 ml-2"
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export default EventForm;
